





















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class VToggleSwitch extends Vue {
  @Prop({ required: true })
  readonly value!: boolean;

  @Prop({ required: false, default: false })
  readonly disabled!: boolean;

  get toggleName() {
    return `toggle_${(this as any)._uid}`;
  }

  private checked: boolean = this.value;
  activate() {
    if (this.disabled) {
      return;
    }
    this.checked = !this.checked;
    this.$emit('input', this.checked);
  }
}
